<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
      <span>COPYRIGHT &copy; {{ new Date().getFullYear() }}
        <a href="" rel="nofollow"
           target="_blank">27Antz</a>, All rights Reserved
      </span>
      <span class="md:flex hidden items-center">
          <span>Version 2.0</span>
      </span>
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
